import { render } from "./product-tips.vue?vue&type=template&id=4d8ddc16&scoped=true"
const script = {}

import "./product-tips.vue?vue&type=style&index=0&id=4d8ddc16&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8ddc16"]])

export default __exports__